export default function ActionButton({
  label,
  variant = "primary",
  onClick,
  type = "button",
  className = "",
  disabled = false,
  children,
}) {
  const base =
    "rounded-md text-sm font-semibold transition-all duration-150 ease-out disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2 active:scale-[0.98]";
  const variants = {
    primary:
      "bg-teal text-white hover:bg-teal-dk shadow-[0_1px_2px_rgba(14,19,32,0.08)] hover:shadow-glow h-10 px-4",
    secondary:
      "bg-white text-navy border border-line hover:border-navy/20 hover:bg-off-white h-10 px-4",
    danger:
      "bg-danger text-white hover:bg-[#C7373C] h-10 px-4",
  };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${variants[variant] || variants.primary} ${className}`}
    >
      {children || label}
    </button>
  );
}
